import { render, staticRenderFns } from "./PartnersList.vue?vue&type=template&id=409be417&scoped=true&"
import script from "./PartnersList.vue?vue&type=script&lang=js&"
export * from "./PartnersList.vue?vue&type=script&lang=js&"
import style0 from "./PartnersList.vue?vue&type=style&index=0&id=409be417&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409be417",
  null
  
)

export default component.exports